import { msg } from "@lingui/core/macro"
import { useLingui } from "@lingui/react"
import { Trans } from "@lingui/react/macro"
import { Alert, Anchor, Button, Stack, Text, TextInput } from "@mantine/core"
import { useCallback, useState } from "react"
import { AuthShell } from "../../-auth-shared/AuthShell"
import type { IProps } from "./interfaces"

export const ForgotPasswordView = ({
  logo,
  appName,
  product,
  loginBackground,
  loading,
  submitted,
  onSubmit,
}: IProps): React.JSX.Element => {
  const [email, setEmail] = useState("")
  const { i18n } = useLingui()

  const handleSubmit = useCallback(
    (e: React.FormEvent): void => {
      e.preventDefault()
      onSubmit(email)
    },
    [email, onSubmit],
  )

  return (
    <AuthShell
      logo={logo}
      appName={appName}
      product={product}
      loginBackground={loginBackground}
      title={<Trans>Reset your password</Trans>}
    >
      {submitted ? (
        <Stack>
          <Alert color="success" variant="light">
            <Trans>If an account exists for that email, we've sent a reset link. Check your inbox.</Trans>
          </Alert>
          <Anchor href="/login" ta="center" size="sm">
            <Trans>Back to sign in</Trans>
          </Anchor>
        </Stack>
      ) : (
        <form onSubmit={handleSubmit}>
          <Stack>
            <Text c="dimmed" size="sm">
              <Trans>Enter your email and we'll send you a link to choose a new password.</Trans>
            </Text>
            <TextInput
              label={i18n._(msg`Email`)}
              placeholder="you@company.com"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.currentTarget.value)}
              required
              autoFocus
            />
            <Button type="submit" fullWidth loading={loading}>
              <Trans>Send reset link</Trans>
            </Button>
            <Anchor href="/login" ta="center" size="sm">
              <Trans>Back to sign in</Trans>
            </Anchor>
          </Stack>
        </form>
      )}
    </AuthShell>
  )
}
